import { ContentWidthMode } from 'utils/entities';
import { BreakpointValue } from 'consts/breakpoints';
import {
  breakpointToContentWidth,
  breakpointToNarrowContentWidth,
  breakpointToWideContentWidth,
} from 'ds/components/Layout';
import { Theme } from 'ds';


export const getRightPositionForMapControlElements = (
  theme: Theme,
  isMapExpanded: boolean,
  offset: number,
  contentWidthMode = ContentWidthMode.Default,
  limitBreakpoints: BreakpointValue[] = [ 3, 4, 5 ]
) =>
  limitBreakpoints.map((key) => isMapExpanded
    ? `right: ${offset}px;`
    : theme.media.showAt({ at: +key as BreakpointValue })`
      right: ${
        (contentWidthMode === ContentWidthMode.Narrow
          ? parseInt(breakpointToNarrowContentWidth[key], 10)
          : contentWidthMode === ContentWidthMode.Default
            ? parseInt(breakpointToContentWidth[key], 10)
            : parseInt(breakpointToWideContentWidth[key], 10)) + offset
      }px;
    `);


export const getRightInsightsPositionForMapControlElements = (
  theme: Theme,
  offset: number,
  contentWidthMode = ContentWidthMode.Default,
  limitBreakpoints: BreakpointValue[] = [ 3, 4, 5 ]
) =>
  limitBreakpoints.map((key) =>
    theme.media.showAt({ at: +key as BreakpointValue })`
      right: ${
        (contentWidthMode === ContentWidthMode.Narrow
          ? 0
          : contentWidthMode === ContentWidthMode.Default
            ? parseInt(breakpointToContentWidth[key], 10) - parseInt(breakpointToNarrowContentWidth[key], 10)
            : parseInt(breakpointToWideContentWidth[key], 10) - parseInt(breakpointToNarrowContentWidth[key], 10)) +
        offset
      }px;
    `);
